import { useGoogleFonts } from "@flayyer/use-googlefonts";

const useFonts = ({ fonts }) => {
  const fontToLoad = fonts.map(({ family = "Comfortaa" }) => {
    let toLoad = "Comfortaa";
    if (family.length) {
      toLoad = family;
    }
    return { family: toLoad, styles: ["regular"] };
  });
  return useGoogleFonts(fontToLoad);
};

export { useFonts };
